import { Injectable, inject } from '@angular/core';

import { CookieService, WINDOW } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class TrackingValueService {
    private readonly windowRef = inject(WINDOW);
    private readonly cookieService = inject(CookieService);
    /**
     * Returns Google Analytics session ID if available.
     */
    get gaSessionId(): string | undefined {
        return this.windowRef?.['ga_session_id'] ?? this.cookieService.get('vn_ga_session_id');
    }

    /**
     * Returns Google Analytics client ID from various possible locations.
     */
    get gaClientId(): string | undefined {
        return this.windowRef?.['ga_client_id'] ?? this.windowRef?.['gaGlobal']?.vid ?? this.cookieService.get('vn_ga_client_id');
    }
}
